import { TripFolderSecondaryTripBooking } from '../../lib/types/models/trip-folder/trip-folder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderSecondaryBookings(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getSecondaryTripBookings.url, { id }))
    .get<TripFolderSecondaryTripBooking[]>()
}
